/**
 * enTete.ts, « EN TÊTE DE FICHE » LU SUR UNE DECLARATION (chantier
 * `fiche-suivi`, `docs/socle/fiche-suivi.md` section 2).
 *
 * Les en-tetes que la rangee 3 d'une fiche montre (`portes[].etapes`, une
 * liste lue par `enTetesDeLaPorte`), chacun un champ a valeurs, se reglent a
 * trois endroits : le Studio d'une app lue (ses lignes, donc les
 * outils MCP du Studio), le formulaire de brief, et les Parametres de la
 * porte. Les deux premiers et le dernier lisent la DECLARATION, et ce module
 * est leur seule lecture des champs offerts : un champ a choix UNIQUE du jeu
 * de la porte (un champ declare `select` avec des valeurs, hors champs
 * masques), ou un natif dont la colonne du catalogue porte les valeurs. Une
 * etape est UNE valeur : un choix multiple n'a pas de place dans la rangee.
 *
 * Le brief, lui, lit son propre modele (`champsDEtapes`, `brief/derive.mjs`) :
 * il juge ce que la derivation ECRIRA, pas ce qui est sur le disque. Les deux
 * passent par la meme regle du socle (`champsDEnTeteDuJeu`, `@taki/data-model`) :
 * un champ masque n'est offert ni ici ni la-bas.
 */
import { champsDEnTeteDuJeu } from '@taki/data-model';

/** Ce qu'il faut de la declaration : l'ecran de la porte, et les jeux du fichier de champs. */
interface EcranLisible {
  colonnes?: readonly { champ: string; label?: string; type?: string; options?: readonly unknown[] }[];
  portes: readonly { id: string; jeu?: { family: string; type?: string } }[];
}
interface JeuLisible {
  family: string;
  type?: string;
  masques?: readonly string[];
  champs: readonly { key: string; label: string; type: string; options?: readonly unknown[] }[];
}

/** Un champ offert : son NOM (le vocabulaire des colonnes) et son libelle. */
export interface ChampDEnTete {
  value: string;
  label: string;
}

/**
 * Les champs que « En tête de fiche » offre sur cette porte ; vide sans jeu.
 * La regle est celle du socle (`champsDEnTeteDuJeu`), lue aussi par le brief.
 */
export function champsDEnTete(ecran: EcranLisible, porteId: string, jeux: readonly JeuLisible[]): ChampDEnTete[] {
  const porte = ecran.portes.find((p) => p.id === porteId);
  const jeu = porte?.jeu;
  if (jeu === undefined) return [];
  const declare = jeux.find((j) => j.family === jeu.family && (j.type ?? '') === (jeu.type ?? ''));
  return champsDEnTeteDuJeu(declare, ecran.colonnes ?? []);
}
